import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import { FormProvider, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import ErrorDisplay from 'components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla';
import useGetInfoSolicitudGastosContingenciaProfesionalIt from 'services/record/SolicitudGastosContingenciaProfesional/useGetInfoSolicitudGastosContingenciaProfesionalIt';
import useGetSolicitudGastosContingenciaProfesionalItByID from 'services/record/SolicitudGastosContingenciaProfesional/useGetSolicitudGastosContingenciaProfesionalItByID';
import useUpdateSolicitudGastosContingenciaProfesionalByID from 'services/record/SolicitudGastosContingenciaProfesional/useUpdateSolicitudGastosContingenciaProfesionalItByID';
import useCreateNewSolicitudGastosContingenciaProfesional from 'services/record/SolicitudGastosContingenciaProfesional/useCreateSolicitudGastosContingenciaProfesionalIt';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import FormInputDropDown from 'components/blocks/ManagementNewForms/Inputs/FormInputDropDown';
import FormCalculadoraKilometraje from 'components/blocks/ManagementNewForms/Inputs/FormCalculadoraKilometraje';
import { on } from 'events';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';


export const SolicitudGastosContingenciaProfesional: React.FC<{ prestacionId: string, userId: string, formId: string, info?: boolean, tipoGasto?: number, onSuccess?: () => void, expedienteId?: string | number | null, origen?: string | number | null }> = ({ prestacionId, userId, formId, info, tipoGasto, onSuccess, expedienteId = null, origen = null }) => {

    const location = useLocation();
    const origenValue = origen ?? location?.state?.origen ?? null;
    const expedienteIdValue = expedienteId ?? location?.state?.expedienteId ?? null;
    const lockExpedienteByOrigenActivo = info === true && Number(origenValue) === 1 && expedienteIdValue !== null && expedienteIdValue !== undefined && expedienteIdValue !== "";

    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;

    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;
    const [datosAPI, setDatosAPI] = useState(null);
    const [expedienteArray, setExpedienteArray] = useState([]);
    const [loader, setLoader] = useState(false);
    const [errorObservacioes, setErrorObservaciones] = useState(false);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [expedienteBloqueadoLabel, setExpedienteBloqueadoLabel] = useState("");
    const [expedienteNoEncontradoError, setExpedienteNoEncontradoError] = useState<string | null>(null);
    const { getInfoSolicitudGastosContingenciaProfesionalIt } = useGetInfoSolicitudGastosContingenciaProfesionalIt()
    const { getSolicitudGastosContingenciaProfesionalById } = useGetSolicitudGastosContingenciaProfesionalItByID();
    const { loadingUpdateSolicitudGastosContingenciaProfesionalById, successUpdateSolicitudGastosContingenciaProfesionalById, errorUpdateSolicitudGastosContingenciaProfesionalById, updateSolicitudGastosContingenciaProfesionalById } = useUpdateSolicitudGastosContingenciaProfesionalByID();
    const { loadingSolicitudGastosContingenciaProfesionalIt, successSolicitudGastosContingenciaProfesionalIt, errorSolicitudGastosContingenciaProfesionalIt, createSolicitudGastosContingenciaProfesionalIt } = useCreateNewSolicitudGastosContingenciaProfesional();
    enum TipoGastoEnum {
        Transporte = 1,
        Farmacia = 2,
        Ortopedia = 3,
    }
    let title;
    let descripcionGasto
    switch (tipoGasto) {
        case TipoGastoEnum.Transporte:
            title = 'Datos del Gasto (Transporte)';
            descripcionGasto = 'Transporte'
            break;
        case TipoGastoEnum.Farmacia:
            title = 'Datos del Gasto (Farmacia)';
            descripcionGasto = 'Farmacia'
            break;
        case TipoGastoEnum.Ortopedia:
            title = 'Datos del Gasto (Ortopedia)';
            descripcionGasto = 'Ortopedia'
            break;
        default:
            title = '';
            descripcionGasto = ''
    }

    const getExpedienteExternalId = (item) => item?.IdExternalPrestacion ?? item?.ExpedienteId ?? null;
    const getPrestacionId = (item) => item?.IdPortalPrestacion ?? item?.IdPrestacion ?? null;
    const getExpedienteLabel = (item) => `${item?.CodigoExpediente ?? ''} - ${getExpedienteExternalId(item) ?? ''}`;
    const isDocumentoObligatorio = true;
    const adaptDocumentacionByTipoGasto = (seccionesDocumentacion) =>
        adaptDocumentacion(seccionesDocumentacion || []).map((doc) => ({
            ...doc,
            Obligatorio: isDocumentoObligatorio,
        }));






    //METODO PARA ADAPTAR LA RESPUESTA DE LA API AL FORMULARIO
    const adaptApiResponseToDefaultValues = (result) => {
        //console.log("RESULTADO", result)

        let expedienteBloqueado = null;
        console.log('result', result)
        if (result?.PrestacionCP != null) {
            const adaptado = result?.PrestacionCP?.map(item => ({
                titulo: `${item.CodigoExpediente ?? item.CodigoExpediente ?? ''} - ${item.IdExternalPrestacion ?? item.ExpedienteId ?? ''}`,
                value: item.IdPrestacion ?? item.IdPrestacion ?? null,
            }));
            console.log('adaptado', adaptado)
            setExpedienteArray(adaptado && adaptado);

            if (lockExpedienteByOrigenActivo) {
                expedienteBloqueado = result.PrestacionCP.find(
                    x => String(getExpedienteExternalId(x) ?? "") === String(expedienteIdValue)
                ) || null;
            }
        }

        if (lockExpedienteByOrigenActivo && expedienteBloqueado) {
            setExpedienteBloqueadoLabel(getExpedienteLabel(expedienteBloqueado));
            setExpedienteNoEncontradoError(null);
        } else if (lockExpedienteByOrigenActivo) {
            setExpedienteBloqueadoLabel("");
            setBloquearEnvio(true);
            setExpedienteNoEncontradoError(`No se encuentra el ExpedienteId ${String(expedienteIdValue)} entre los Expedientes del Usuario.`);
            return;
        } else {
            setExpedienteBloqueadoLabel("");
            setExpedienteNoEncontradoError(null);
        }

        if (result?.IBAN == null) {
            setValue("DatosBancarios.SolicitanteIBANIBAN", "");
            setValue("DatosBancarios.SolicitanteIBANEntidad", "");
            setValue("DatosBancarios.SolicitanteIBANSucursal", "");
            setValue("DatosBancarios.SolicitanteIBANDC", "");
            setValue("DatosBancarios.SolicitanteIBANNumeroCuenta", "");
        }
        else {
            setValue("DatosBancarios.SolicitanteIBAN", result?.NumeroCuentaConIBAN?.replace(/-/g, ''));
        }
        setErrorObservaciones(result.EstadoFormulario == 2 ? true : false);
        reset({
            DatosPersonales: {
                SolicitanteNombre: result?.DatosPersonales?.Nombre || "",
                SolicitanteApellido1: result?.DatosPersonales?.Apellido1 || "",
                SolicitanteApellido2: result?.DatosPersonales?.Apellido2 || "",
                SolicitanteIPF: result?.DatosPersonales?.IPF || "",
                SolicitanteIPFTipo: result?.DatosPersonales?.IPFTipo?.toString() || "1",

                SolicitanteTelefono: result?.DatosPersonales?.Telefono || "",
                SolicitanteFijo: result?.DatosPersonales?.Fijo || "",
                SolicitanteDomicilio: result?.DatosPersonales?.Domicilio || "",
                SolicitanteCodigoPostal: result?.DatosPersonales?.CodigoPostal || "",
                SolicitanteProvincia: result?.DatosPersonales?.CodigoProvincia || "",
                SolicitanteProvinciaDescripcion: result?.DatosPersonales?.Provincia || "",
                SolicitanteComunidadCodigo: result?.DatosPersonales?.CodigoLocalidad || "",

            },
            TipoGastos: {
                FechaGasto: result?.FechaGasto || "",
                DescripcionGasto: result?.DescripcionGasto || "",
                Importe: result?.Importe || null,
                DireccionOrigen: result?.DireccionOrigen ?? null,
                DireccionDestino: result?.DireccionDestino ?? null,
                DistanciaOrigenDestino: result?.DistanciaOrigenDestino ?? null,
                ExpedienteGasto: info
                    ? (lockExpedienteByOrigenActivo ? (getPrestacionId(expedienteBloqueado) ?? "") : "")
                    : `${result?.CodigoExpediente} - ${result?.ExpedienteId}`,
                Documentacion: adaptDocumentacionByTipoGasto(result?.SeccionesDocumentacion),
            },
            DatosBancarios: {
                SolicitanteIBAN: result?.IBAN?.replace(/-/g, '') || "",
            }
        });

    };

    //////////////////// SABER SI ES HISTORIAL O NO Y OBTENER LOS DATOS ////////////
    useEffect(() => {
        let isActive = true;
        const fetchData = async () => {
            setLoader(true);
            if (userId != "") {
                try {
                    if (info === true) {
                        let result = await getInfoSolicitudGastosContingenciaProfesionalIt(userId);
                        if (result && isActive) {
                            adaptApiResponseToDefaultValues(result)
                            setDatosAPI(result)
                        }
                    }
                    else {
                        let result = await getSolicitudGastosContingenciaProfesionalById(userId, prestacionId, formId);
                        if (result && isActive) {
                            adaptApiResponseToDefaultValues(result)
                            setDatosAPI(result)
                        }
                    }
                } catch (error) {
                    console.error("Error al obtener los datos:", error);
                } finally {
                    if (isActive) {
                        setLoader(false);
                    }
                }
            }

        };

        fetchData(); // Llamar a la función asincrónica
        return () => {
            isActive = false;
        };
    }, [userId, prestacionId, formId, info, lockExpedienteByOrigenActivo, expedienteIdValue]);


    ///////////////////// BLOQUEAR POR PESO DE ARCHIVO ////////////////
    useEffect(() => {
        if (totalSize > 50) {
            setBloquearEnvio(true)
        }
        else {
            setBloquearEnvio(false)
        }
    }, [totalSize]);


    //////////////////////////// ON SUBMIT ////////////////////////
    const onSubmit = async (data: any) => {
        setLoader(true);

        if (expedienteNoEncontradoError) {
            setLoader(false);
            return;
        }

        console.log(data);

        const expediente = data?.TipoGastos?.ExpedienteGasto;
        const encontrado = lockExpedienteByOrigenActivo
            ? datosAPI?.PrestacionCP?.find(
                x => String(getExpedienteExternalId(x) ?? "") === String(expedienteIdValue)
            )
            : datosAPI?.PrestacionCP?.find(
                x => (x.IdPortalPrestacion ?? x.IdPrestacion) === expediente
            );

        const expedienteIdToSend = getExpedienteExternalId(encontrado) ?? datosAPI?.ExpedienteId ?? null;


        const documentacionArray = await prepareDocumentacionArrayWithCase(data?.TipoGastos?.Documentacion || []);
        const distanciaOrigenDestino = data?.TipoGastos?.DistanciaOrigenDestino;

        const datosEnvio: any = {
            Id: formId || 0,
            UsuarioId: userId || 0,
            PersonaId: datosAPI?.PersonaId || 0,

            ExpedienteId: info
                ? expedienteIdToSend ?? null
                : datosAPI.ExpedienteId,
            PrestacionId: info
                ? getPrestacionId(encontrado) ?? null
                : datosAPI.PrestacionId,

            Acepto: data?.Acepto || false,
            TipoGasto: tipoGasto,

            DatosPersonales: {
                Nombre: data?.DatosPersonales?.SolicitanteNombre || "",
                Apellido1: data?.DatosPersonales?.SolicitanteApellido1 || "",
                Apellido2: data?.DatosPersonales?.SolicitanteApellido2 || "",
                IPF: data?.DatosPersonales?.SolicitanteIPF || "",
                IPFTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,

                Telefono: data?.DatosPersonales?.SolicitanteTelefono || "",
                Fijo: data?.DatosPersonales?.SolicitanteFijo || "",
                Domicilio: data?.DatosPersonales?.SolicitanteDomicilio || "",
                CodigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || "",
                ProvinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
                CodigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,

                CodigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
                LocalidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,

            },
            CodigoExpediente: info
                ? encontrado?.CodigoExpediente ?? encontrado?.CodigoExpediente ?? null
                : datosAPI.CodigoExpediente,

            Provincia: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
            CodigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,
            DescripcionGasto: data?.TipoGastos?.DescripcionGasto || '',
            Importe: data?.TipoGastos?.Importe
                ? parseFloat(String(data.TipoGastos.Importe).replace(',', '.')) || null
                : null,
            DireccionOrigen: data?.TipoGastos?.DireccionOrigen || '',
            DireccionDestino: data?.TipoGastos?.DireccionDestino || '',
            DistanciaOrigenDestino: distanciaOrigenDestino !== undefined && distanciaOrigenDestino !== null && distanciaOrigenDestino !== ''
                ? parseFloat(String(distanciaOrigenDestino).replace(',', '.')) || null
                : null,
            Iban:
                data?.DatosBancarios?.SolicitanteIBAN
                    ?.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-') || null,


            Documentacion: documentacionArray
        };

        //console.log("Datos ENvio", datosEnvio)
        if (info) {
            await createSolicitudGastosContingenciaProfesionalIt(userId, expedienteIdToSend, datosEnvio, onSuccess);
            setBloquearEnvio(true);
        } else {
            await updateSolicitudGastosContingenciaProfesionalById(userId, prestacionId, formId, datosEnvio, onSuccess);
            setBloquearEnvio(true);
        }

        if (successSolicitudGastosContingenciaProfesionalIt || successUpdateSolicitudGastosContingenciaProfesionalById) {
            setBloquearEnvio(true)
        }

        setTimeout(() => {
            setLoader(false);
        }, 500);
    };

    return (
        <>
            <Loader activeLoader={loader || loadingSolicitudGastosContingenciaProfesionalIt || loadingUpdateSolicitudGastosContingenciaProfesionalById} label="Cargando Formulario"></Loader>


            {expedienteNoEncontradoError ? (
                <ErrorDisplay descripcionError={expedienteNoEncontradoError} />
            ) : (
                <FormProvider {...formMethods}>
                    <div className="container form--simple-styled" id="formDeltawithoutleave">
                        <div className="col-xl-12 mt-5">

                        </div>

                        <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la solicitud'} errorColor={errorObservacioes} />



                        <FormInfoCreateUpdate
                            isCreate={info}
                            estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario}
                            estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.EstadoFormularioDescripcion}
                            fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado}
                        />
                        <FormDatosPersonales />

                        <AccordionForm title={title} expandedInit={false} nombreError='TipoGastos' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
                            <div className="row">
                                <div className="col-xl-12">
                                    <FieldsetContainer legend="Tipo y Descripción de Gastos" disabled={false}>
                                        <FormInputText
                                            name='TipoGastos.TipoGasto'
                                            id='TipoGastos.TipoGasto'
                                            label='Tipo de Gasto'
                                            md={3}
                                            xl={3}
                                            disabled={true}
                                            defaultValue={tipoGasto == 1 ? 'Transporte' : tipoGasto == 2 ? 'Farmacia' : 'Ortopedia'}
                                        />
                                        <FormInputText
                                            name='TipoGastos.Importe'
                                            id='TipoGastos.Importe'
                                            label='Importe'
                                            md={3}
                                            xl={3}
                                            pattern={/^[0-9]+([.,][0-9]+)?$/}
                                            patternMessage='Introduce un decimal valido usando "." o "," '
                                            modal='El Importe debe corresponder a la suma de los gastos que adjunta y justifica en los tickets'
                                            req='El Importe es Obligatorio'
                                        />
                                        {/* <FormCalculadoraKilometraje
                                            name='TipoGastos.ViajesVehiculoPropio'
                                            id='TipoGastos.ViajesVehiculoPropio'
                                            label='Viajes en vehículo propio'
                                            required='Debe añadir al menos un viaje'
                                            xl={12}
                                            md={12}
                                            col={12}

                                        /> */}
                                        {
                                            info ?
                                                (lockExpedienteByOrigenActivo && expedienteBloqueadoLabel ?
                                                    <>
                                                        <input type='hidden' {...register('TipoGastos.ExpedienteGasto')} />
                                                        <FormInputText
                                                            key={expedienteBloqueadoLabel}
                                                            name='TipoGastos.ExpedienteGastoBloqueado'
                                                            id='TipoGastos.ExpedienteGastoBloqueado'
                                                            label='Prestación relacionada al gasto'
                                                            md={6}
                                                            xl={6}
                                                            disabled={true}
                                                            defaultValue={expedienteBloqueadoLabel}
                                                        />
                                                    </>
                                                    :
                                                    <FormInputDropDown
                                                        name="TipoGastos.ExpedienteGasto"
                                                        label="Prestación relacionada al gasto"
                                                        required="Debe seleccionar una Prestacion"
                                                        options={expedienteArray}
                                                        xl={6}
                                                        md={6}
                                                        col={12}
                                                        placeholder='Selecciona un expediente'
                                                    />)
                                                :
                                                <FormInputText
                                                    name='TipoGastos.ExpedienteGasto'
                                                    id='TipoGastos.ExpedienteGasto'
                                                    label='Prestación relacionada al gasto'
                                                    md={6}
                                                    xl={6}
                                                    disabled={true}
                                                />
                                        }





                                    </FieldsetContainer>
                                    <FormArrayArchivosReducidos
                                        name={'TipoGastos.Documentacion'}
                                        urlArchivos={datosAPI?.Documentacion?.map(d => d?.SasUri) || []}
                                        setTotalSize={setTotalSize}
                                    />
                                </div>
                            </div>
                        </AccordionForm>

                        {/* ////////////// DATOS BANCARIOS //////////// */}
                        <AccordionForm title={'Datos de Abono'} expandedInit={false} nombreError='DatosBancarios' >
                            <div className="row mb-4">
                                <div className="col-xl-12">

                                    <div className="row mb-4">
                                        <div className="col-xl-12">

                                            <FormInputCuentaBancaria
                                                id='DatosBancarios.SolicitanteIBAN'
                                                name='DatosBancarios.SolicitanteIBAN'
                                                xl={12}
                                                md={12}
                                                placeholder=''
                                                req='Falta el Número de Cuenta Bancaria'

                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </AccordionForm>

                        {/* ////////////// ACEPTACION DE LA DECLARACIÓN Y BOTON ENVIAR //////////// */}

                        <FormBotonSubmit
                            disableSubmit={bloquearEnvio}
                            onSubmit={handleSubmit(onSubmit)}
                            successCreate={successSolicitudGastosContingenciaProfesionalIt}
                            successUpdate={successUpdateSolicitudGastosContingenciaProfesionalById}
                            errorCreate={errorSolicitudGastosContingenciaProfesionalIt}
                            errorUpdate={errorUpdateSolicitudGastosContingenciaProfesionalById}
                            datosAPI={datosAPI}
                            info={info}
                            BloqueoForm={[1, 3, 4, 5]}
                            MaxSizeMB={MAX_SIZE_MB}
                        />

                        {/* ////////////// TEXTOS LEGALES //////////// */}

                        <div className='paragraph text-info  mt-5'>Solo se abonarán gastos que estén debidamente justificados y autorizados por
                            Solimat Mutua Colaboradora con la Seguridad Social nº 72.</div>
                        <br></br>
                        <br></br>
                        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de
                            carácter personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                            cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                            podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso,
                            remitiendo un escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus
                            derechos no han sido debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia
                            Española de Protección de Datos.</p>

                    </div>


                </FormProvider>
            )}

        </>
    )
}

export default SolicitudGastosContingenciaProfesional;
